import React from 'react';
import { VisibilityOptions } from 'types/Dataset';

export const visibilityOptions = [
    {
        label: 'Limited',
        value: VisibilityOptions.Limited,
    },
    {
        label: 'Private',
        value: VisibilityOptions.Private,
    },
];

export default function DatasetVisibilityTooltip() {
    return (
        <div className="flex flex-col gap-8">
            <div>Select the visibility level for your dataset:</div>
            <div>
                <b>Limited:</b> Visible to everyone, but permissions required to
                gain access to dataset content.
            </div>
            <div>
                <b>Private:</b> Only visible by dataset owners and those part of
                admin group.
            </div>
        </div>
    );
}
